module.exports = __webpack_public_path__ + "blackstretch.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackstretch.png
// module id = 869
// module chunks = 0